import React from 'react';
import { Navbar } from 'react-bootstrap';
import { NavBarLogin } from './navbar-login';

export const Header: React.FC<React.PropsWithChildren<any>> = () => {
  return (
    <Navbar expand="sm" className="text-end">
      <NavBarLogin />
    </Navbar>
  );
};
